import React, { useState } from 'react';
import { Button, Table } from 'reactstrap';
import { toast } from "react-toastify";
import _ from 'lodash';
import { ItemTypeahead, ServiceThreadSpinner } from '.';
import { DesktopContainer } from '../layouts';
import { api } from '../utils';

export default function CopySpec() {
   const defaultSelect = { label: "--- Select ---", value: "" };
   const [loading, setLoading] = useState(false);
   const [screenForm, setScreenForm] = useState({
      payload: {
         fromItem: defaultSelect,
         toItem: defaultSelect,
      },
   });

   const onChange = (property, value) => {
      let copy = _.cloneDeep(screenForm);
      _.set(copy, property, value);
      setScreenForm(copy);
      return;
   };

   function save() {
      let warnings = [];
      let fromItm = screenForm.payload.fromItem.value;
      let toItm = screenForm.payload.toItem.value;

      if (!fromItm || fromItm === defaultSelect) {
         warnings.push('Select an item to copy from\n');
      }
      if (!toItm || toItm === defaultSelect) {
         warnings.push('Select an item to copy to\n');
      }
      if (toItm && !toItm.startsWith(fromItm)) {
         warnings.push('The copy item number must be a derivative of the from item number\n');
      }
      if (warnings.length) {
         toast.error(warnings.join(''));
         return;
      }

      setLoading(true);
      api
         .post(`Quality/CopySpecification/${fromItm}/${toItm}`)
         .then(response => {
            if (response.data.success) {
               toast.success(`Specification copied successfully!`);
               onChange("payload.fromItem", defaultSelect);
               onChange("payload.toItem", defaultSelect);
            }
            else {
               toast.error(response.data.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setLoading(false);
         });
   }

   return (
      <>
         <DesktopContainer screenName="Copy Specification">
            <ServiceThreadSpinner on={loading}>
               <div className="filter-header stick-top divCenter800px">
                  <label className="h6 text-white fw-bold m-0 px-3">This feature is used to copy the specification from an existing item to create a specification for an item created in Great Plains and NOT in the web site's New Item Code page.<br /><br />Such items generally end with an alphabet character (i.e. PM02004A or PM02004B instead of PM02004) and are basically the same item with a minor modification.</label>
                  <br />
                  <br />
                  <Table borderless size="sm">
                     <tbody>
                        <tr>
                           <td className="data-cell my-0 py-0">
                              <label className="h6 text-white fw-bold m-0 px-3">From Item:</label>
                           </td>
                        </tr>
                        <tr>
                           <td className="data-cell my-0 py-0 px-3">
                              <ItemTypeahead
                                 value={screenForm.payload.fromItem ?? defaultSelect}
                                 onChange={(opt) => onChange("payload.fromItem", opt)}
                                 includeSampleItems={false}
                              />
                           </td>
                        </tr>

                        <tr><td className="data-cell m-0 px-3 lineheight15">&nbsp;</td></tr>
                        <tr>
                           <td className="data-cell my-0 py-0">
                              <label className="h6 text-white fw-bold m-0 px-3">To Item: (Must be the same as the base from item with an extra alpha character at the end)</label>
                           </td>
                        </tr>
                        <tr>
                           <td className="data-cell my-0 py-0 px-3">
                              <ItemTypeahead
                                 value={screenForm.payload.toItem ?? defaultSelect}
                                 onChange={(opt) => onChange("payload.toItem", opt)}
                              />
                           </td>
                        </tr>

                        <tr><td className="data-cell m-0 p-0">&nbsp;</td></tr>
                        <tr><td className="data-cell m-0 p-0 lineheight15">&nbsp;</td></tr>
                        <tr>
                           <td className="data-cell my-0 py-0 px-3">
                              <Button
                                 title="save"
                                 className="shredButton w-100 btn-md my-0"
                                 onClick={() => { save(); }}>
                                 Copy
                              </Button>
                           </td>
                        </tr>
                     </tbody>
                  </Table>
               </div>
            </ServiceThreadSpinner>
         </DesktopContainer >
      </>
   );
}
